import { Stack } from '@mui/material'
import FatnessChart from 'components/cattles/fatnessPage/shared/FatnessChart'
import useFatnessInfoForGraph from 'hook/query/useFatnessInfoForGraph'
import { LicensesType } from 'models/IUserData'
import moment from 'moment'
import { useAppSelector } from 'store/hooks'

import ExpandableCard from 'ui/expandable-card/ExpandableCard'
import Preloader from 'ui/Preloader'
import { ExpiredLicense } from '../../../ui/expired-license/ExpiredLicense'
import DateRangePicker from 'ui/DatePickerInput/DateRangePicker'

interface IFatnessCard {
	groupId: number
}

export const FatnessCard = (props: IFatnessCard) => {
	const { groupId } = props
	const {
		normalCategories,
		deviationCategories,
		obesityCategories,
		emaciationCategories,
		timestamp,
		onChangeCallback,
		dateRange,
		isLoading,
		error,
		shouldAggregateMonthly,
	} = useFatnessInfoForGraph({ groupId })
	const { userData } = useAppSelector(state => state.userReducer)
	const licenseInfo = userData?.company?.licenses?.find(
		el => el.license_codename === LicensesType.FATNESS,
	)
	return (
		<ExpandableCard title={'Упитанность'} hideToggle>
			<Stack direction={'column'} gap={'24px'} minHeight={'278px'} mt={'24px'}>
				<DateRangePicker
					onChangeUpdateDate={onChangeCallback}
					monthFilter={true}
					yearFilter={true}
					currentRange={'Месяц'}
					startDate={dateRange.startDate}
					endDate={dateRange.endDate}
				/>
				{isLoading ? (
					<Preloader mt={8} />
				) : error?.response?.status === 450 ? (
					<ExpiredLicense
						mt={'80px'}
						availableLicenceDates={`Доступен просмотр данных за период ${moment(
							licenseInfo.start_dt,
						).format('DD.MM.YY')} - ${moment(licenseInfo.until_dt).format(
							'DD.MM.YY',
						)}`}
					/>
				) : (
					<FatnessChart
						normalCategories={normalCategories}
						deviationCategories={deviationCategories}
						obesityCategories={obesityCategories}
						emaciationCategories={emaciationCategories}
						timestamp={timestamp}
						shouldUseCategoryAxis={shouldAggregateMonthly}
						startDate={dateRange.startDate}
						endDate={dateRange.endDate}
					/>
				)}
			</Stack>
		</ExpandableCard>
	)
}

export default FatnessCard

FatnessCard.displayName = 'FatnessCard'
